import { render, staticRenderFns } from "./RecognitionDashboard.vue?vue&type=template&id=40d28c99&scoped=true&"
import script from "./RecognitionDashboard.vue?vue&type=script&lang=js&"
export * from "./RecognitionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionDashboard.vue?vue&type=style&index=0&id=40d28c99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d28c99",
  null
  
)

export default component.exports